import { render, staticRenderFns } from "./PlacanjeSacuvaj.vue?vue&type=template&id=6f5ad507&"
import script from "./PlacanjeSacuvaj.vue?vue&type=script&lang=js&"
export * from "./PlacanjeSacuvaj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports